import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackClick } from '../utils/analytics';
import {
  MinimalGlobalStyle,
  Container,
  Inner,
  BackButton,
  Header,
  HeroRow,
  Avatar,
  HeroText,
  PageTitle,
  Bio,
  HeaderLinks,
  HeaderLink,
  Section,
  SectionTitle,
  Card,
  CardTop,
  CardTitle,
  CardDescription,
  CardLinks,
  InternalLink,
  ProjectCard,
  StatsGrid,
  StatCell,
  StatValue,
  StatLabel,
} from '../components/minimal';
import {
  kernel,
  browsers,
  tools,
  buildApps,
  writeups,
  buildStats,
  buildBio,
} from '../data/build';

const BuildPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLinkClick = (project: string, label: string) => {
    trackClick('build_link', { project, link_type: label });
  };

  return (
    <>
      <MinimalGlobalStyle />
      <Container>
        <BackButton />
        <Inner>
          <Header>
            <HeroRow>
              <Avatar>
                <img src="/profile.jpg" alt="Thomas Ryan" />
              </Avatar>
              <HeroText>
                <PageTitle>Thomas Ryan</PageTitle>
                <Bio>{buildBio}</Bio>
              </HeroText>
            </HeroRow>
            <HeaderLinks>
              <HeaderLink href="https://github.com/Atomics-hub" target="_blank" rel="noopener noreferrer">GitHub</HeaderLink>
              <HeaderLink href="https://hackerone.com/a5omic" target="_blank" rel="noopener noreferrer">HackerOne</HeaderLink>
              <HeaderLink href="https://bugcrowd.com/h/A5omic" target="_blank" rel="noopener noreferrer">Bugcrowd</HeaderLink>
              <HeaderLink href="https://x.com/A5omic" target="_blank" rel="noopener noreferrer">X</HeaderLink>
              <HeaderLink href="https://www.linkedin.com/in/thomas-ryan-a5omic" target="_blank" rel="noopener noreferrer">LinkedIn</HeaderLink>
              <HeaderLink as="button" onClick={() => { trackClick('build_to_merch'); navigate('/merch'); }}>BRICK 001</HeaderLink>
            </HeaderLinks>
          </Header>

          <StatsGrid>
            <StatCell>
              <StatValue>{buildStats.bugsFixed}</StatValue>
              <StatLabel>Bugs fixed upstream</StatLabel>
            </StatCell>
            <StatCell>
              <StatValue>{buildStats.productsLive}</StatValue>
              <StatLabel>Products live</StatLabel>
            </StatCell>
            <StatCell>
              <StatValue>{buildStats.monthlyReach}</StatValue>
              <StatLabel>Monthly reach</StatLabel>
            </StatCell>
          </StatsGrid>

          <Section>
            <SectionTitle>Kernel</SectionTitle>
            {kernel.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Browsers</SectionTitle>
            {browsers.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Tools</SectionTitle>
            {tools.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Writeups</SectionTitle>
            {writeups.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
          </Section>

          <Section>
            <SectionTitle>Apps</SectionTitle>
            {buildApps.map(p => (
              <ProjectCard key={p.title} project={p} onLinkClick={handleLinkClick} />
            ))}
            <Card>
              <CardTop>
                <CardTitle>23+ Web Applications</CardTitle>
              </CardTop>
              <CardDescription>
                Shipped web apps spanning AI tools, real-time data visualization, games, and developer utilities.
              </CardDescription>
              <CardLinks>
                <InternalLink onClick={() => { trackClick('build_web_apps'); navigate('/web-apps'); }}>
                  View all &rarr;
                </InternalLink>
              </CardLinks>
            </Card>
          </Section>

          <Section>
            <SectionTitle>More</SectionTitle>
            <Card>
              <CardDescription>
                Looking for the full career detail or a deep dive on specific security findings?
              </CardDescription>
              <CardLinks>
                <InternalLink onClick={() => { trackClick('build_to_portfolio'); navigate('/portfolio'); }}>
                  Career detail &rarr;
                </InternalLink>
                <InternalLink onClick={() => { trackClick('build_to_research'); navigate('/research'); }}>
                  Security deep-dive &rarr;
                </InternalLink>
                <InternalLink onClick={() => { trackClick('build_to_nexus'); navigate('/nexus'); }}>
                  Writing &amp; everything else &rarr;
                </InternalLink>
              </CardLinks>
            </Card>
          </Section>
        </Inner>
      </Container>
    </>
  );
};

export default BuildPage;
